import  {FC, useEffect, useMemo, useRef, useState} from 'react'
import {Link, useLocation} from 'react-router-dom'
import {ToastContainer} from 'react-toastify'
import {fetchData, formatDatePublic, toasterrormsg} from '../../../reusable'
import {PageTitle} from '../../../_metronic/layout/core'
import {CarRentalDetailsHeader} from './CarRentalDetailsHeader'
import {KTIcon} from '../../../_metronic/helpers'
import {Tr} from '../../../_metronic/i18n/Tr'
import DataTable from 'react-data-table-component'

const ViewCarRentalContract: FC = () => {
  let t = Tr()
  const location = useLocation()
  const carrentalId = (location.state as any)?.carrentalId || ''
  const vendorId= (location.state as any)?.vendorId || ''
  const [carRentalDetailList, setCarRentalDetailList] = useState([])
    const [orgCarRentalDetailList, setOrgCarRentalDetailList] = useState([])
    const [searchTerm, setSearchTerm] = useState('')
    const [url, setUrl] = useState('')
    const [focus, setFocus] = useState('')
  
    const carRentalContractDetailListApiCall = async () => {
      var param: any = {
        actionId: carrentalId,
        categoryId: '7',
      }  
      var response: any = await fetchData('admin/contracthistory', param)
  
      if (response.status == '200') {  
        setCarRentalDetailList(response.data)
        setOrgCarRentalDetailList(response.data)
      } else {
        toasterrormsg(response.message)
      }
    }

    // Fetch the latest contract URL
    const latestContractUrlApiCall = async () => {
    const param = {
      categoryId: '7',
      actionId: carrentalId,
      vendorId: vendorId,
    }

    const res = await fetchData('admin/generatePdfContract', param)

    if (res.status == '200') {
      const data = res.data
      if (data.url) {
        setUrl(data.url)
      } else {
        toasterrormsg('Document URL not found.')
      }
    } else {
      toasterrormsg(res.message)
    }
  }

  // Function to handle download or view of the contract URL
  const proceedWithUrl = (event: any) => {
    if (url) {
      if (event == 'download') {
        const link = document.createElement('a')
        link.href = url
        link.download = '' // Leave blank to use filename from server
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      } else if (event == 'view') {
        window.open(url, '_blank')
      }
    }
  }
  
    useEffect(() => {
      carRentalContractDetailListApiCall()
      latestContractUrlApiCall()
    }, [])
  
    const column = useMemo(
    () => [
      {
        name: `${t('Field Changed')}`,
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.label ? row.label : '-'}</div>
          </div>
        ),
        sortable: true,
        filter: true,
        selector: (row: any) => Number(row.label),
      },
      {
        name: `${t('Old Value')}`,
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.oldValue ? row.oldValue : '-'}</div>
          </div>
        ),
        sortable: true,
        filter: true,
        selector: (row: any) => Number(row.oldValue),
      },
      {
        name: `${t('New Value')}`,
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.newValue ? row.newValue : '-'}</div>
          </div>
        ),
        sortable: true,
        filter: true,
        selector: (row: any) => String(row.newValue),
      },

      {
        name: `${t('Changed On')}`,
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.created ? formatDatePublic(row.created) : '-'}</div>
          </div>
        ),
        sortable: true,
        filter: true,
        selector: (row: any) => Number(row.created),
      },
    ],
    [t]
  )
    const CustomHeader = (props: any) => {
      const inputRef: any = useRef(null)
  
      // Define the onchange event handler
      const handleChange = async (e: any) => {
        // Focus on the input element when the onchange event is triggered
        await props.customSearch(e, 1)
      }
      useEffect(() => {
        // Check if the ref exists and if the component should be focused
        if (inputRef.current && props.isfoc === 1) {
          inputRef.current.focus()
        }
      }, [props.isfoc])
  
      return (
        <div className='d-flex justify-content-between align-items-center w-100 my-5'>
        {/* Search Input */}
        <div className='d-flex align-items-center position-relative my-1'>
          <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-6' />
          <input
            type='text'
            data-kt-user-table-filter='search'
            className='form-control form-control-solid w-250px ps-14'
            placeholder={`${t('Search Contract History')}`}
            value={props.search}
            onChange={(e: any) => handleChange(e.target.value)}
            ref={inputRef}
          />
        </div>

        {/* Buttons on the right */}
        <div className='d-flex gap-2'>
          <button
            className='btn btn-sm btn-success'
            onClick={(e) => {
              proceedWithUrl('download')
            }}
          >
           {`${t('Download Current Document')}`}
          </button>
          <button
            className='btn btn-sm btn-primary'
            onClick={(e) => {
              proceedWithUrl('view')
            }}
          >
            {`${t('View Current Document')}`}
          </button>
        </div>
      </div>
      )
    }
  
    
    const contractSearch = async (text: any, isfoc: any) => {
    setSearchTerm(text)
    setFocus(isfoc)

    if (text == '' || text == null || text == undefined) {
      setCarRentalDetailList(orgCarRentalDetailList)
    } else {
      var tmp: any = orgCarRentalDetailList.filter((item: any) => {
        return (
          (item.label != null &&
            item.label != '' &&
            String(item.label).toLowerCase().includes(text.toLowerCase())) ||
          (item.oldValue != null &&
            item.oldValue != '' &&
            String(item.oldValue).toLowerCase().includes(text.toLowerCase())) ||
          (item.newValue != null &&
            item.newValue != '' &&
            String(item.newValue).toLowerCase().includes(text.toLowerCase())) ||
          (item.created != null &&
            item.created != '' &&
            String(item.created).toLowerCase().includes(text.toLowerCase()))
        )
      })

      setCarRentalDetailList(tmp)
    }
  }
  return (
    <>
      <PageTitle breadcrumbs={[]}>{t("Car Rental Contract")}</PageTitle>
      <ToastContainer />
      <CarRentalDetailsHeader />
     <div className='card'>
        {/* <!--begin::Card header--> */}
        <div className='card-header'>
          {/* <!--begin::Card header--> */}
          <div className='card-title fs-3 fw-bold'>{t('Contract History')}</div>
          {/* <!--end::Card header--> */}
        </div>
        {/* <!--end::Card header--> */}
        {/* <!--begin::Card body--> */}
        <div className='card-body'>
          <>
            <DataTable
              columns={column}
              data={carRentalDetailList}
              pagination
              paginationServer={false}
              subHeader={true}
              subHeaderComponent={
                <CustomHeader search={searchTerm} isfoc={focus} customSearch={contractSearch} />
              }
            />
          </>
        </div>
      </div>
    </>
  )
}

export {ViewCarRentalContract}
